import { useNavigate, useSearchParams } from "react-router-dom";
import { PageHeader, cardCls } from "@/components/shared";
import { LinkItemForm, extractUrl } from "@/components/shop/LinkItemForm";

export default function SharePage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const title = params.get("title") || "";
  const text = params.get("text") || "";
  const url = params.get("url") || extractUrl(text) || extractUrl(title);
  const hint = title && !extractUrl(title) ? title : "";
  const back = () => navigate("/lists?tab=wishlist", { replace: true });

  return (
    <div data-testid="share-page">
      <PageHeader eyebrow="Shared with Base and Balance" title="Add to wishlist" subtitle="We've pulled in what we could. Check the details and choose a wishlist." />
      <div className={`${cardCls} p-6 sm:p-8 max-w-2xl`}>
        <LinkItemForm initialUrl={url} initialName={hint} onDone={back} onCancel={back} />
      </div>
    </div>
  );
}
